/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetEmployeesInput = {
  badgeNumbers: Array<string>;
};

export type IdentifyEmployeeMutationVariables = Exact<{
  badgeNo: string;
}>;

export type IdentifyEmployeeMutation = {
  identifyEmployee: {
    badgeNo: string;
    displayName: string | null;
    isActive: boolean | null;
    roles: Array<string>;
  };
};

export type GetEmployeesNameByBadgeNoQueryVariables = Exact<{
  input: Types.GetEmployeesInput;
}>;

export type GetEmployeesNameByBadgeNoQuery = {
  getEmployees: Array<{ badgeNo: string; displayName: string | null }>;
};

export const IdentifyEmployeeDocument = gql`
  mutation identifyEmployee($badgeNo: String!) {
    identifyEmployee(badgeNo: $badgeNo) {
      badgeNo
      displayName
      isActive
      roles
    }
  }
`;
export type IdentifyEmployeeMutationFn = Apollo.MutationFunction<
  IdentifyEmployeeMutation,
  IdentifyEmployeeMutationVariables
>;

/**
 * __useIdentifyEmployeeMutation__
 *
 * To run a mutation, you first call `useIdentifyEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyEmployeeMutation, { data, loading, error }] = useIdentifyEmployeeMutation({
 *   variables: {
 *      badgeNo: // value for 'badgeNo'
 *   },
 * });
 */
export function useIdentifyEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IdentifyEmployeeMutation,
    IdentifyEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IdentifyEmployeeMutation, IdentifyEmployeeMutationVariables>(
    IdentifyEmployeeDocument,
    options,
  );
}
export type IdentifyEmployeeMutationHookResult = ReturnType<typeof useIdentifyEmployeeMutation>;
export type IdentifyEmployeeMutationResult = Apollo.MutationResult<IdentifyEmployeeMutation>;
export type IdentifyEmployeeMutationOptions = Apollo.BaseMutationOptions<
  IdentifyEmployeeMutation,
  IdentifyEmployeeMutationVariables
>;
export const GetEmployeesNameByBadgeNoDocument = gql`
  query getEmployeesNameByBadgeNo($input: GetEmployeesInput!) {
    getEmployees(input: $input) {
      badgeNo
      displayName
    }
  }
`;

/**
 * __useGetEmployeesNameByBadgeNoQuery__
 *
 * To run a query within a React component, call `useGetEmployeesNameByBadgeNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesNameByBadgeNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesNameByBadgeNoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmployeesNameByBadgeNoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeesNameByBadgeNoQuery,
    GetEmployeesNameByBadgeNoQueryVariables
  > &
    ({ variables: GetEmployeesNameByBadgeNoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeesNameByBadgeNoQuery, GetEmployeesNameByBadgeNoQueryVariables>(
    GetEmployeesNameByBadgeNoDocument,
    options,
  );
}
export function useGetEmployeesNameByBadgeNoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeesNameByBadgeNoQuery,
    GetEmployeesNameByBadgeNoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeesNameByBadgeNoQuery,
    GetEmployeesNameByBadgeNoQueryVariables
  >(GetEmployeesNameByBadgeNoDocument, options);
}
// @ts-ignore
export function useGetEmployeesNameByBadgeNoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeesNameByBadgeNoQuery,
    GetEmployeesNameByBadgeNoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeesNameByBadgeNoQuery,
  GetEmployeesNameByBadgeNoQueryVariables
>;
export function useGetEmployeesNameByBadgeNoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeesNameByBadgeNoQuery,
        GetEmployeesNameByBadgeNoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeesNameByBadgeNoQuery | undefined,
  GetEmployeesNameByBadgeNoQueryVariables
>;
export function useGetEmployeesNameByBadgeNoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeesNameByBadgeNoQuery,
        GetEmployeesNameByBadgeNoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEmployeesNameByBadgeNoQuery,
    GetEmployeesNameByBadgeNoQueryVariables
  >(GetEmployeesNameByBadgeNoDocument, options);
}
export type GetEmployeesNameByBadgeNoQueryHookResult = ReturnType<
  typeof useGetEmployeesNameByBadgeNoQuery
>;
export type GetEmployeesNameByBadgeNoLazyQueryHookResult = ReturnType<
  typeof useGetEmployeesNameByBadgeNoLazyQuery
>;
export type GetEmployeesNameByBadgeNoSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeesNameByBadgeNoSuspenseQuery
>;
export type GetEmployeesNameByBadgeNoQueryResult = Apollo.QueryResult<
  GetEmployeesNameByBadgeNoQuery,
  GetEmployeesNameByBadgeNoQueryVariables
>;
